import {
    RaikoBaseContainer, RaikoBreadcrumb, raikoBreadCrumbItemGenerator, RaikoButtonSecondary,
    RaikoFlexFirstChildGrowOne,
    RaikoGridOneColumn
} from "@moeindal/base-raiko-panel-components";
import {RouteHelper} from "../../../route/RouteHelper";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import React, {useState} from "react";
import {Helmet} from "react-helmet";
import TabContext from "@mui/lab/TabContext";
import Box from "@mui/material/Box";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import MemorialNoteInfo from "./memorialNoteInfo/MemorialNoteInfo";
import MemorialNotePublished from "./memorialNotePublished/MemorialNotePublished";

export default function MemorialNoteDetails() {

    const {state} = useLocation()

    const {id: memorialNoteId} = useParams()

    const [pageTitle, setPageTitle] = useState(state && state.title ? state.title : RouteHelper.MemorialNote.name);


    const navigate = useNavigate()

    const [tabSelectedValue, setTabSelectedValue] = useState(memorialNoteDetailsTabTypes.memorialNoteInfo.id);

    function handleChangeTab(event, newValue) {
        setTabSelectedValue(newValue)
    }


    return (
        <>
            <Helmet>
                <title>{RouteHelper.MemorialNoteDetails.name}</title>
            </Helmet>
            <RaikoBaseContainer>
                <RaikoGridOneColumn>
                    <RaikoFlexFirstChildGrowOne>
                        <RaikoBreadcrumb
                            breadCrumbItems={[
                                raikoBreadCrumbItemGenerator(
                                    RouteHelper.MemorialNote.name,
                                    ""
                                ),
                                raikoBreadCrumbItemGenerator(
                                    RouteHelper.MemorialNotes.name,
                                    RouteHelper.MemorialNotes.globalUrl
                                ),
                                raikoBreadCrumbItemGenerator(
                                    pageTitle,
                                    ""
                                ),
                            ]}
                        />
                        <RaikoButtonSecondary label={"بازگشت"} onClick={_ => {
                            navigate(-1)
                        }}/>
                    </RaikoFlexFirstChildGrowOne>

                    <TabContext value={tabSelectedValue}>
                        <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                            <TabList onChange={handleChangeTab} id="default-tab-container" variant="scrollable">
                                <Tab
                                    label={memorialNoteDetailsTabTypes.memorialNoteInfo.title}
                                    value={memorialNoteDetailsTabTypes.memorialNoteInfo.id}/>
                                <Tab
                                    label={memorialNoteDetailsTabTypes.published.title}
                                    value={memorialNoteDetailsTabTypes.published.id}/>

                            </TabList>
                        </Box>
                        <TabPanel value={memorialNoteDetailsTabTypes.memorialNoteInfo.id}>
                            <MemorialNoteInfo memorialNoteId={memorialNoteId}/>
                        </TabPanel>
                        <TabPanel value={memorialNoteDetailsTabTypes.published.id}>
                            <MemorialNotePublished memorialNoteId={memorialNoteId}/>
                        </TabPanel>
                    </TabContext>
                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>

    )
}
const memorialNoteDetailsTabTypes = {
    memorialNoteInfo: {
        id: "detail",
        title: "اطلاعات دلنوشته"
    },
    published: {
        id: "published",
        title: "وضعیت انتشار"
    },
}
